import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import CarouselContents from '../CarouselContents';
import CarouselSwiper from '../CarouselSwiper';

class Carousel extends Component {
  constructor(props) {
    super(props);

    const {
      initialise,
      carouselsStoreDataKey,
      children,
      noPerPage,
      infinite,
    } = this.props;

    this.setPageIDs();

    const noOfItems = children.length;

    initialise({
      carouselsStoreDataKey,
      noOfItems,
      noPerPage,
      infinite,
    });
  }

  componentDidUpdate(prevProps) {
    const {
      setNoOfPages,
      carouselsStoreDataKey,
      children,
      noPerPage,
    } = this.props;

    if (prevProps.children.length !== children.length) {
      this.setPageIDs();
    }

    const noOfItems = children.length;

    setNoOfPages({ carouselsStoreDataKey, noOfItems, noPerPage });
  }

  setPageIDs() {
    const { children } = this.props;
    this.pageIds = children.map(() => uuid());
  }

  render() {
    const {
      headingLevel,
      carouselsStoreDataKey,
      isCarouselFullWidth,
      isCarouselContentFullWidth,
      setIndex,
      buttons,
      pagination,
      rightChevronIconSrc,
      leftChevronIconSrc,
      children,
      carouselData = {},
      carouselContent = {},
      onIndexChange,
      infinite,
      showPagination = true,
      noPerPage,
    } = this.props;

    const { currentIndex = 0, noOfPages = 1 } = carouselData;
    const { title } = carouselContent;
    const labelledbyId = `carousel-heading-${carouselsStoreDataKey}`;
    const HeadingTag = `h${headingLevel}`;
    const hasGrid = !isCarouselFullWidth || !isCarouselContentFullWidth;

    const carouselContentsProps = {
      carouselsStoreDataKey,
      buttons,
      pagination,
      rightChevronIconSrc,
      leftChevronIconSrc,
      children,
      pageIds: this.pageIds,
      onIndexChange,
      infinite,
      showPagination,
      noPerPage,
    };

    return (
      <CarouselSwiper
        setIndex={setIndex}
        carouselsStoreDataKey={carouselsStoreDataKey}
        currentIndex={currentIndex}
      >
        <div
          className="carousel"
          aria-labelledby={labelledbyId}
        >
          <HeadingTag className="show-for-sr" id={labelledbyId}>{title}</HeadingTag>
          <div className="show-for-sr" aria-live="polite" aria-atomic="true">
            {
              // TODO: localise this text
              `Item ${currentIndex + 1} of ${noOfPages}`
            }
          </div>
          { hasGrid && (
            <div className="grid-container">
              { !isCarouselFullWidth && (
                <div className="carousel__relative-wrapper">
                  <CarouselContents {...carouselContentsProps} />
                </div>
              )}
              { isCarouselFullWidth && <CarouselContents {...carouselContentsProps} /> }
            </div>
          )}
          { !hasGrid && <CarouselContents {...carouselContentsProps} />}
        </div>
      </CarouselSwiper>
    );
  }
}

Carousel.propTypes = {
  carouselsStoreDataKey: PropTypes.string.isRequired,
  pagination: PropTypes.objectOf(PropTypes.any),
  buttons: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.node.isRequired,
  initialise: PropTypes.func.isRequired,
  setIndex: PropTypes.func.isRequired,
  setNoOfPages: PropTypes.func.isRequired,
  headingLevel: PropTypes.number.isRequired,
  carouselData: PropTypes.objectOf(PropTypes.any).isRequired,
  carouselContent: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
  isCarouselFullWidth: PropTypes.bool,
  isCarouselContentFullWidth: PropTypes.bool,
  rightChevronIconSrc: PropTypes.string,
  leftChevronIconSrc: PropTypes.string,
  onIndexChange: PropTypes.func,
  noPerPage: PropTypes.number,
  infinite: PropTypes.bool,
  showPagination: PropTypes.bool,
};

export default Carousel;
